<template>
  <div id="companiesComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="companySearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
          <v-dialog
            persistent
            v-model="dialog"
            max-width="700px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on"
              >
                <v-icon left>add</v-icon>
                {{ $t('company.add') }}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid"
                  >
                  <v-text-field
                    clearable
                    required
                    :rules="rules.textRules"
                    prepend-icon="edit"
                    :label="$t('general.name')"
                    :error-messages="errors.name"
                    v-model="editedItem.name"
                    @keyup.enter="save"
                  >
                  </v-text-field>
                  <v-layout>
                    <v-text-field
                      class="mr-3"
                      clearable
                      required
                      mask="NNNNNNNNNNNNN"
                      :rules="rules.taxRules"
                      :error-messages="errors.tax_id"
                      prepend-icon="edit"
                      :label="$t('taxFields.taxId')"
                      v-model="editedItem.tax_id"
                      @keyup.enter="save"
                    >
                    </v-text-field>
                    <v-text-field
                      clearable
                      required
                      mask="(###) ###-####"
                      :rules="rules.phoneRules"
                      prepend-icon="edit"
                      :label="$t('taxFields.phone')"
                      :error-messages="errors.phone"
                      v-model="editedItem.phone"
                      @keyup.enter="save"
                    >
                    </v-text-field>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <v-select
                        class="mr-3"
                        required
                        :rules="rules.required"
                        prepend-icon="edit"
                        clearable
                        :items="regimenList"
                        item-text="descripcion"
                        item-value="descripcion"
                        :label="$t('taxFields.regime')"
                        :error-messages="errors.regimen_fiscal"
                        v-model="editedItem.regimen_fiscal"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        clearable
                        required
                        :rules="rules.textRules"
                        prepend-icon="edit"
                        :label="$t('taxFields.socialReason')"
                        v-model="editedItem.razon_social"
                        :error-messages="errors.razon_social"
                        @keyup.enter="save"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout s12>
                    <v-flex>
                      <span>{{ $t('general.logo') }}:</span>
                      <v-img
                        v-if="editedItem.logo"
                        height="200"
                        contain
                        class="mb-2"
                        :src="editedItem.logo.public_url">
                      </v-img>
                      <v-img
                        v-if="dataURL"
                        :src="dataURL"
                        height="200"
                        contain
                        class="mb-2">
                      </v-img>
                      <vue-dropzone
                        ref="dropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-file-added="fileAdded"
                        v-on:vdropzone-error="fileUploadError"
                        v-on:vdropzone-success="fileUpload">
                      </vue-dropzone>
                    </v-flex>
                  </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close"
                >
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  color="primary"
                  round
                  depressed
                  @click="save"
                >
                  {{ $t('general.submit') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
      <v-data-table
        :search="companySearch"
        class="elevation-2"
        :headers="headers"
        :items="companies"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
      >
      <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
            >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td width="60px">{{props.item.id}}</td>
          <td class="text-sm-center">{{props.item.name}}</td>
          <td class="text-sm-center">{{props.item.tax_id}}</td>
          <td class="text-sm-center">{{props.item.phone}}</td>
          <td class="text-sm-center">{{props.item.regimen_fiscal}}</td>
          <td class="text-sm-center">{{props.item.razon_social}}</td>
          <td class="text-sm-center">
            <v-chip v-if="props.item.isVigent"
             :color="colorSuccessChip"
             :text-color="textColor"
             >
              <v-icon>
                check_circle
              </v-icon>
              {{ $t('subscriptions.vigent') }}
             </v-chip>
            <v-chip v-else
              :color="colorErrorChip"
              :text-color="textColor"
            >
              <v-icon>
                error
              </v-icon>
              {{ $t('subscriptions.expired') }}
            </v-chip>
          </td>
          <td class="justify-center layout px-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  outline
                  icon
                  color="info"
                  v-on="on"
                  small
                  @click="editItem(props.item)"
                >
                  <v-icon small>edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('general.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                outline
                icon
                color="error"
                v-on="on"
                small
                @click="removed(props.item)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
              </template>
              <span>{{ $t('general.delete') }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      </v-data-table>
      <v-dialog
        persistent
        v-model="removeDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('general.deleteElement') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('general.name') }}: </span>{{removedItem.name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="error"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="removeItem(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
export default {
  name: 'companiesComponent',
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      companySearch: '',
      colorSuccessChip: 'success',
      colorErrorChip: 'error',
      textColor: 'white',
      pagination: {
        descending: true,
        page: 1,
        orderBy: 'created_at',
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', { size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png',
        maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.access_token },
        params: {
          'dirname': 'COMPANY_LOGO',
          'is_public': 1,
          'user_id': this.user_id
        }
      },
      errorMessagg: '',
      userLogged: {
        id: null
      },
      dialog: false,
      removeDialog: false,
      valid: true,
      errors: {},
      loading: false,
      editedIndex: -1,
      removedItem: {},
      originalItem: {},
      editedItem: {
        id: 0,
        name: '',
        tax_id: '',
        phone: '',
        regimen_fiscal: '',
        razon_social: '',
        logo: null,
        file: null
      },
      dataURL: null,
      fileId: null,
      defaultItem: {
        id: 0,
        name: '',
        tax_id: '',
        phone: '',
        regimen_fiscal: '',
        razon_social: '',
        logo: null,
        file: null
      },
      companies: [],
      company: null,
      regimenList: [],
      areas: []
    }
  },
  computed: {
    heading () {
      return this.$t('general.companies')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-building fa-fw icon-color'
    },
    formTitle () { // watch the dialog title
      return this.editedIndex === -1 ? this.$t('company.add') : this.$t('company.edit')
    },
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('taxFields.taxId'),
          align: 'center',
          value: 'tax_id',
          sortable: true
        },
        {
          text: this.$t('taxFields.phone'),
          align: 'center',
          value: 'phone',
          sortable: true
        },
        {
          text: this.$t('taxFields.regime'),
          align: 'center',
          value: 'regimen_fiscal',
          sortable: true
        },
        {
          text: this.$t('taxFields.socialReason'),
          align: 'center',
          value: 'razon_social',
          sortable: true
        },
        {
          text: this.$t('general.status'),
          align: 'center',
          value: 'isVigent',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    user_id () {
      return this.userLogged.id
    },
    access_token () {
      return this.$store.state.userState.access_token
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    user_id () {
      this.dropzoneOptions.params.user_id = this.user_id
      this.dropzoneOptions.headers.Authorization = 'Bearer ' + this.access_token
    },
    '$store.state.userLogged' () {
      this.getLogged()
    }
  },
  created () {
    this.getLogged()
    this.initialize()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    removed (item) { // set the item that want to remove and open the dialog
      this.removedItem = item
      this.removeDialog = true
    },
    removeItem (item) { // change the status of the users to '0'
      const index = this.companies.indexOf(item)
      this.loading = true
      this.delete(item, index)
    },
    closeRemoveDialog () {
      this.loading = false
      this.removeDialog = false
    },
    close () { // close the dialog and re-assing default values
      this.dialog = false
      this.loading = false
      this.dataURL = null
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
      this.errors = {}
    },
    editItem (item) { // show the element that want to edit
      // this.$store.dispatch('getFile', {
      //   event: {
      //     context: this,
      //     fileId: item.logo.id
      //   }
      // })
      this.editedIndex = this.companies.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.originalItem = Object.assign({}, item)
      this.dialog = true
    },
    save () { // evaluate the form and save de values
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
          this.loading = true
        }
      }
    },
    initialize () { // Getting the elements for companies and the regimen library
      this.$emit('companies_get', {context: this})
      this.$emit('regimen_get', {context: this})
      // this.$emit('userLogged', {context: this})
    },
    post () { // method to post an element in to de DB
      this.$emit('companies_post', {item: this.editedItem, context: this})
    },
    put () { // method to edit an element in the DB
      this.$emit('companies_put', {item: this.editedItem, index: this.editedIndex, context: this})
    },
    delete (item, index) { // method to remove an element from de DB
      this.$emit('companies_delete', {item: item, index: index, context: this})
    },
    refresh () {
      this.$emit('refresh', { context: this })
    },
    fileAdded (file) {
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      }
    },
    fileUpload (file, response) {
      this.editedItem.file = response.data.id
    },
    fileUploadError (file, message, xhr) {
      // if (message.errors !== null && message.errors !== undefined) {
      //   // let notificationMessage = message.message + '<br>'
      //   let notificationMessage = ''
      //   if (message.errors.path) {
      //     message.errors.path.forEach(element => {
      //       notificationMessage += element + '<br>'
      //     })
      //   }
      //   if (message.errors.files_type_id) {
      //     message.errors.files_type_id.forEach(element => {
      //       notificationMessage += element + '<br>'
      //     })
      //   }
      //   this.showNotification(notificationMessage, 'error', -1)
      // }
      this.showNotification(message, 'error', -1)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/companies.component.vue